const extractErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  if (err?.networkError?.result?.errors?.[0]?.message) return err.networkError.result.errors[0].message;
  if (err?.graphQLErrors?.[0]?.message) return err.graphQLErrors[0].message;
  if (err?.message) return err.message;
  return fallback;
};

export default extractErrorMessage;
